import * as React from "react";
import type { SVGProps } from "react";
export const SvgUggPriceBadge = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 99 102" {...props}>
    <g filter="url(#ugg-price-badge_svg__a)">
      <path
        fill="#191937"
        d="M25.082 11.592C29.173 2.4 40.58-.858 48.908 4.787A16.185 16.185 0 0 0 61.877 7.09c9.665-2.4 19.23 4.366 20.143 14.282l.051.556A16.74 16.74 0 0 0 88.43 33.58l.216.17c7.928 6.199 8.524 18.002 1.298 25.008a16.487 16.487 0 0 0-5.007 12.23l.011.45c.247 9.953-8.524 17.735-18.378 16.304-4.547-.66-9.16.657-12.672 3.62-7.612 6.419-19.17 4.444-24.218-4.14l-.227-.386a16.487 16.487 0 0 0-10.712-7.741c-9.835-2.132-15.564-12.47-12.106-21.92l.095-.26a16.74 16.74 0 0 0-.755-13.252l-.25-.5c-4.462-8.902.087-19.698 9.56-22.766a16.185 16.185 0 0 0 9.797-8.805Z"
      />
      <path
        stroke="#F4C874"
        strokeWidth={0.783}
        d="M25.44 11.751c3.992-8.968 15.121-12.147 23.247-6.64A16.578 16.578 0 0 0 61.972 7.47c9.433-2.342 18.766 4.262 19.658 13.938l.05.556a17.133 17.133 0 0 0 6.508 11.925l.217.17c7.74 6.051 8.323 17.577 1.267 24.418a16.878 16.878 0 0 0-5.126 12.521l.01.448c.242 9.712-8.316 17.305-17.93 15.909a16.465 16.465 0 0 0-12.982 3.706c-7.426 6.264-18.702 4.337-23.626-4.037l-.227-.386a16.88 16.88 0 0 0-10.967-7.926C9.22 76.63 3.627 66.535 7.003 57.309l.095-.258a17.134 17.134 0 0 0-.773-13.564l-.25-.499c-4.353-8.687.084-19.224 9.331-22.218A16.577 16.577 0 0 0 25.44 11.75Z"
      />
    </g>
    <defs>
      <filter
        id="ugg-price-badge_svg__a"
        width={99}
        height={101.15}
        x={0}
        y={0}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={2} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_11592_12508" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_11592_12508" result="shape" />
      </filter>
    </defs>
  </svg>
);
